export default __webpack_public_path__ + "static/patrick_wang_resume-90e19601a256b9ca76d466f65e06e904.pdf";